import React, {Component} from 'react'

export default class Bio extends Component {
  componentWillMount() {
    this.props.toggleWork(false);
  }

  render() {
    return (
      null
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bio.js